module.exports = __webpack_public_path__ + "static/img/chanta (16).3bf9809.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (16).jpg
// module id = PLKw
// module chunks = 0